export default __webpack_public_path__ + "static/media/map-marker.aab22404.svg";